var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logisticsMap"},[_c('div',{staticClass:"baiduMap",attrs:{"id":"map-chart"}})])
}]

export { render, staticRenderFns }